import { Link } from 'react-router-dom'
import { buttonVariants } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 py-24 text-center">
      <h1 className="text-3xl font-semibold">404</h1>
      <p className="text-muted-foreground text-sm">Такой страницы в консоли нет.</p>
      <Link to="/" className={buttonVariants()}>
        На главную
      </Link>
    </div>
  )
}
